import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";

export default function Adminnavbar() {
  const navigate = useNavigate();

  // ===== STATES =====
  const [adminEmail, setAdminEmail] = useState("");
  const [isToggled, setIsToggled] = useState(false);

  // ===== GET ADMIN EMAIL =====
  useEffect(() => {
    setAdminEmail(localStorage.getItem("adminEmail") || "");
  }, []);

  // ===== SIDEBAR TOGGLE =====
  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  // ===== LOGOUT =====
  const handleLogout = () => {
    Swal.fire({
      title: "Logout",
      text: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(`${process.env.REACT_APP_BACKEND_BASE_URL}/user/logout`)
          .then((res) => {
            if (res.status === 200) {
              localStorage.removeItem(process.env.REACT_APP_LOGIN_DATA_STORE);
              navigate("/login");
              Swal.fire({
                icon: "success",
                title: "User Logout",
                timer: 1500,
                showConfirmButton: false,
              });
            }
          })
          .catch((err) => console.log(err));
      }
    });
  };

  return (
    <>
      {/* ================= HEADER ================= */}
      <div className="header">
        <div className="header-left">
          <NavLink to="/" className="logo">
            <img
              src="/assets/img/ca-logo.jpg"
              alt="Logo"
              width="80"
              height="80"
            />
          </NavLink>
        </div>

        {/* MOBILE TOGGLE */}
        <div
          onClick={handleToggle}
          className={isToggled ? "navbartog mobile_btn" : "mobile_btn"}
        >
          <i className="fas fa-align-left"></i>
        </div>

        <div className="header-split">
          <div className="page-headers">
            <div className="search-bar">
              <span>
                <i className="fe fe-search"></i>
              </span>
              <input
                type="text"
                placeholder="Search"
                className="form-control"
              />
            </div>
          </div>

          {/* USER MENU */}
          <ul
            className="nav user-menu"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <li className="nav-item logout-box">
              {adminEmail && (
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#26448c",
                  }}
                >
                  {adminEmail}
                </span>
              )}

              <button
                type="button"
                onClick={handleLogout}
                title="Logout"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "38px",
                  height: "38px",
                  borderRadius: "50%",
                  border: "1px solid #26448c",
                  background: "#fff",
                  cursor: "pointer",
                }}
              >
                <i
                  className="fa-solid fa-arrow-right-from-bracket"
                  style={{ color: "#26448c" }}
                ></i>
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* ================= SIDEBAR ================= */}
      <div
        onClick={handleToggle}
        className={isToggled ? "navbartog sidebar" : "sidebar"}
        id="sidebar"
      >
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <NavLink to="/">
              <img
                src="/assets/img/ca-logo.jpg"
                className="img-fluid logo"
                alt=""
              />
            </NavLink>

            <NavLink to="/">
              <img
                src="/assets/img/ca-logo.jpg"
                className="img-fluid logo-small"
                alt=""
              />
            </NavLink>
          </div>
        </div>

        <div className="sidebar-inner slimscroll">
          <div id="sidebar-menu" className="sidebar-menu">
            <ul>
              <li>
                <NavLink to="/admindashbord">
                  <i className="fa-solid fa-house"></i>
                  <span>Dashboard</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/knowledge-center-list">
                  <i className="fa-solid fa-layer-group"></i>
                  <span>Knowledge Center</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/ppt-tool-list">
                  <i className="fa-solid fa-upload"></i>
                  <span>PPT & Tools Download</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/pdf-download-list">
                  <i className="fa-solid fa-file-pdf"></i>
                  <span>PDF Download List</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/job-list">
                  <i className="fa-solid fa-briefcase"></i>
                  <span>Jobs</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/job-application-list">
                 <i className="fa-solid fa-file-lines"></i>
                  <span>Jobs Application</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/candidate-inquiry-list">
                  <i className="fa-solid fa-user-tie"></i>
                  <span> Inquiry</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/calendar-list">
                  <i className="fa-solid fa-calendar-days"></i>
                  <span>Calendar</span>
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* ================= /SIDEBAR ================= */}
    </>
  );
}
